import Phaser from 'phaser';
import { SCENES, COLORS, GAME } from '../config/gameConfig';

/**
 * PreloadScene - Loads all game assets and shows loading progress
 * Transitions to MenuScene when complete.
 */
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENES.PRELOAD });
  }

  preload(): void {
    this.cameras.main.setBackgroundColor(COLORS.BACKGROUND);

    // Create loading bar
    const width = GAME.WIDTH;
    const height = GAME.HEIGHT;

    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();

    progressBox.fillStyle(COLORS.UI_ACCENT, 0.3);
    progressBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50);

    // Loading text
    const loadingText = this.add.text(width / 2, height / 2 - 50, 'Loading...', {
      fontFamily: 'Arial',
      fontSize: '24px',
      color: '#2D3436',
    });
    loadingText.setOrigin(0.5, 0.5);

    // Progress events
    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(COLORS.PLATFORM, 1);
      progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30);
    });

    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
    });

    // Load assets here when available
    // For now, we have no assets to load, so it will complete immediately
  }

  create(): void {
    // Transition to menu after a brief delay for visual feedback
    this.time.delayedCall(100, () => {
      this.scene.start(SCENES.MENU);
    });
  }
}
